import { Component, OnInit, Input } from '@angular/core';

export interface AnnotationData {
  id: string,
  type: string,
  label: string,
  thumbnail?: string,
  thumbnailIcon?: string,
  thumbnailSVG?: string,
  userPercentage: number
}
@Component({
  selector: 'annotation-stat-item',
  templateUrl: './annotation-stat-item.component.html',
  styleUrls: ['./annotation-stat-item.component.scss']
})
export class AnnotationStatItemComponent implements OnInit {
  @Input() data: AnnotationData;
  label: string;
  constructor() { }

  ngOnInit(): void {
  }
  getLabel() {
    return (this.data.userPercentage || 0) + '%';
  }
}
